var defaultCssModule = {"collapse":"__collap_B1__11-2-1","entering":"__collap_entering7__11-2-1","entered":"__collap_entered11__11-2-1","exiting":"__collap_exiting15__11-2-1","exited":"__collap_exited19__11-2-1"};

export default defaultCssModule;
